// const URL_PROD = "https://ims.nepallife.com.np/backend/api";
const URL_UAT = "https://ims.nepallife.com.np/uat/backend/api";
// const URL_UAT = "https://altinv-suman.ut.prologicnepal.com/api";
// const URL_UAT = "http://192.168.110.16:8000/api";
// const URL_UAT = "http://192.168.110.101:8000/api";
const URL_PROD = "https://ims.nepallife.com.np/uat/backend/api";
// const URL_UAT = URL_PROD;

const isProduction = process.env.NODE_ENV === "production";

const ServerUrl = isProduction ? URL_PROD : URL_UAT;

export const ServerUrlImage = isProduction
  ? `${URL_PROD}/storage/fd/images`
  : `${URL_UAT}/storage/fd/images`;

export default ServerUrl;
